import { customEventListener } from '@helpers/customEventListener.js';

(() => {
	customEventListener('#cookiemodal .btn--morecookieinfo', 'click', e => {
		e.preventDefault();
		const cookiemodal = document.querySelector('#cookiemodal');
		const cookiemodalstart = cookiemodal.querySelector('.cookiemodal__start');
		const cookiemodaloptions = cookiemodal.querySelector('.cookiemodal__options');
		cookiemodalstart.hidden = true;
		cookiemodaloptions.hidden = false;

		// Preselect 'block all cookies' option
		const categoryOption = document.querySelector('#radio-1');
		categoryOption.checked = true;
	});

	customEventListener('#cookiemodal .btn--showdetailedcookieinfo', 'click', e => {
		e.preventDefault();
		const cookiemodal = document.querySelector('#cookiemodal');
		const cookiemodalHideButton = cookiemodal.querySelector('.btn--hidedetailedcookieinfo');
		const cookiemodalShowButton = cookiemodal.querySelector('.btn--showdetailedcookieinfo');
		const cookiemodaldeclaration = cookiemodal.querySelector('.cookiemodal__declaration');

		cookiemodalHideButton.hidden = false;
		cookiemodalShowButton.hidden = true;
		cookiemodaldeclaration.hidden = !cookiemodaldeclaration.hidden;
	});

	customEventListener('#cookiemodal .btn--hidedetailedcookieinfo', 'click', e => {
		e.preventDefault();
		const cookiemodal = document.querySelector('#cookiemodal');
		const cookiemodalHideButton = cookiemodal.querySelector('.btn--hidedetailedcookieinfo');
		const cookiemodalShowButton = cookiemodal.querySelector('.btn--showdetailedcookieinfo');
		const cookiemodaldeclaration = cookiemodal.querySelector('.cookiemodal__declaration');

		cookiemodalHideButton.hidden = true;
		cookiemodalShowButton.hidden = false;
		cookiemodaldeclaration.hidden = !cookiemodaldeclaration.hidden;
	});

	customEventListener('#cookiemodal [role="tab"]', 'click', e => {
		// eslint-disable-next-line prefer-destructuring
		const target = e.target;
		const parent = target.parentNode;
		const grandparent = parent.parentNode;
		const groupedBy = target.dataset.group;
		parent.querySelectorAll(`[data-group="${groupedBy}"][aria-selected="true"]`).forEach(t => t.setAttribute('aria-selected', false));
		target.setAttribute('aria-selected', true);

		grandparent.querySelectorAll(`[data-group="${groupedBy}"][role="tabpanel"]`).forEach(p => p.setAttribute('hidden', true));
		grandparent.parentNode.querySelector(`#${target.getAttribute('aria-controls')}`).removeAttribute('hidden');
	});

	customEventListener('#cookiemodal .selected-cookies__input', 'change', () => {
		const categoryOption = document.querySelector('#radio-2');
		categoryOption.checked = true;
	});

	customEventListener('#cookiemodal [name="OptInLevel"]', 'change', () => {
		const categoryOptions = document.querySelectorAll('[name="OptInCategory"]');
		categoryOptions.forEach(option => option.checked = false);
	});

	customEventListener('#cookiemodal', 'submit', e => {
		e.preventDefault();

		const formElement = document.getElementById('cookiemodalform');
		const formData = new FormData(formElement);
		let xmlhttp;
		if (window.XMLHttpRequest) {
			xmlhttp = new XMLHttpRequest();
		} else {
			xmlhttp = new ActiveXObject('Microsoft.XMLHTTP');
		}
		xmlhttp.onreadystatechange = function () {
			if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
				location.reload();
				return false;
			}
		};
		xmlhttp.open(formElement.method, formElement.action);
		xmlhttp.send(formData);
		return false;
	});
})();
